import * as React from "react";
import {Outlet, useOutletContext} from "react-router";
import {loadQuery} from "react-relay/hooks";
import {useIntl} from "react-intl";
import Link from "./navigation/Link";
import AnalysisForecastOverviewViewQuery from "./__generated__/AnalysisForecastOverviewViewQuery.graphql";

type AnalysisForecastViewProps = {
    prepared: any
};

/**
 * The "Forecast" tab of the analysis. It passes the preloaded queries of the analysis and of the
 * forecast on to the area shown.
 */
const AnalysisForecastView: React.FC<AnalysisForecastViewProps> = ({prepared}) => {
    const intl = useIntl();
    const outletContext = useOutletContext();

    const areas = [
        {label: intl.formatMessage({id: 'view.analysisForecast.area.overview'}), to: '/analysis/forecast/overview'},
        {label: intl.formatMessage({id: 'view.analysisForecast.area.accounts'}), to: '/analysis/forecast/accounts'},
        {label: intl.formatMessage({id: 'view.analysisForecast.area.bwa'}), to: '/analysis/forecast/bwa'},
        {label: intl.formatMessage({id: 'view.analysisForecast.area.plannedItems'}), to: '/analysis/forecast/planned-items'},
    ];

    return (
        <div className="space-y-6 px-4 sm:px-6 lg:px-0">
            <nav className="inline-flex rounded-md bg-gray-100 p-0.5" aria-label="Forecast">
                {areas.map(area => (
                    <Link
                        key={area.to}
                        to={area.to}
                        className="text-sm px-4 py-1.5 font-medium rounded transition-all duration-150 text-gray-500 hover:text-gray-700"
                        activeClassName="bg-white text-gray-900! shadow-xs"
                    >
                        {area.label}
                    </Link>
                ))}
            </nav>
            <Outlet context={{...(outletContext as object), ...prepared}}/>
        </div>
    );
};

export default AnalysisForecastView;

/**
 * The forecast takes a few seconds to compute, so its query is only requested once the forecast
 * tab is opened, not with the rest of the analysis.
 */
export function prepare_AnalysisForecastView(_params: any, relayEnvironment: any) {
    return {
        forecastOverviewQuery: loadQuery(
            relayEnvironment,
            AnalysisForecastOverviewViewQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
    };
}
